export const cpfMask = (value: string) =>
  value.replace(/(\d)(\d{2})$/, '$1-$2').replace(/(?=(\d{3})+(\D))\B/g, '.');

export const phoneMask = (value: string) =>
  value
    .replace('+55', '')
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{4,5})(\d{4})/, '$1-$2');

export const cnpjMask = (value: string) =>
  value
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 14)
    .replace(
      /^([A-Z0-9]{2})([A-Z0-9]{1,3})([A-Z0-9]{0,3})([A-Z0-9]{0,4})(\d{0,2})/,
      (_, p1, p2, p3, p4, p5) =>
        p1 +
        '.' +
        p2 +
        (p3 ? '.' + p3 : '') +
        (p4 ? '/' + p4 : '') +
        (p5 ? '-' + p5 : '')
    );

export const cnpjUnmask = (value: string) =>
  value.toUpperCase().replace(/[^A-Z0-9]/g, '');

export const cepMask = (value: string) =>
  value.replace(/\D/g, '').replace(/(\d)(\d{3})$/, '$1-$2');
